/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback, useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { ThemeEditor } from "./ThemeEditor";
import { Layout } from "../../../ui/components/Layout/Layout";
import {
	ThemeEditorInspector,
	ThemeEditorMain,
	ThemeEditorOutline,
	ThemeEditorOutlineToolbar,
	ThemeEditorSecondaryToolbar
} from "./components";
import { ThemeEditorMainToolbar } from "./components/ThemeEditorMainToolbar";

export const ThemeEditorComponent: TViewComponent<ThemeEditor> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), [ view ]);
	const themeModel = useMemo(() => view.getThemeModel(), [ view ]);

	const renderComponent = useCallback(
		(componentName: string) => {
			switch (componentName) {
				case "outlineContent":
					return <ThemeEditorOutline themeModel={themeModel} />;
				case "outlineToolbar":
					return <ThemeEditorOutlineToolbar themeModel={themeModel} />;
				case "mainContent":
					return <ThemeEditorMain themeModel={themeModel} />;
				case "mainToolbar":
					return <ThemeEditorMainToolbar view={view} />;
				case "secondaryMainToolbar":
					return <ThemeEditorSecondaryToolbar view={view} themeModel={themeModel} />;
				case "componentPalette":
					return <div>component palette</div>;
				case "inspector":
					return <ThemeEditorInspector themeModel={themeModel} />;
				case "settings":
					return <div>settings</div>;
				default:
					return <p>Error: Undefined panel {componentName}.</p>;
			}
		},
		[ view ]
	);

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
